{
  "cards": [
    {"id": "vowel", "label": "vowel → +s", "examples": "casas, livros, pés", "tip": "Words ending in a vowel → +s."},
    {"id": "ao", "label": "-ão words", "examples": "corações, pães, mãos", "tip": "", "tipRows": ["-ão → -ões usually, but some become", "-ão → -ães (pão → pães)", "-ão → -ãos (mão → mãos)"]},
    {"id": "es", "label": "-r / -z / -n / stressed -s → +es", "examples": "flores, luzes, meses, países", "tip": "-r, -z, -n, and stressed -s → +es"},
    {"id": "m", "label": "-m → -ns", "examples": "homens, jardins", "tip": "-m → -ns"},
    {"id": "l", "label": "-l / -il words", "examples": "animais, papéis, lençóis, fáceis, funis", "tip": "-l endings:", "tipRows": ["-al → -ais", "-el → -éis", "-ol → -óis", "-ul → -uis", "-il → -is if stressed (funil → funis)", "-il → -eis if not (fácil → fáceis)"]},
    {"id": "invariable", "label": "-s / -x: no change", "examples": "lápis, ônibus", "tip": "No change — article alone shows the plural.", "note": "Only the article shows the plural: o lápis → os lápis."},
    {"id": "irregular", "label": "irregulars", "examples": "cães, alemães, cônsules, caracteres", "tip": "Irregular — memorize.", "note": "Memorize per word."}
  ],
  "items": [
    {"card": "vowel", "article": "a", "singular": "casa", "plural": "casas"},
    {"card": "vowel", "article": "o", "singular": "livro", "plural": "livros"},
    {"card": "vowel", "article": "o", "singular": "pé", "plural": "pés"},
    {"card": "vowel", "article": "a", "singular": "mesa", "plural": "mesas"},
    {"card": "vowel", "article": "o", "singular": "carro", "plural": "carros"},
    {"card": "vowel", "article": "a", "singular": "escola", "plural": "escolas"},
    {"card": "vowel", "article": "o", "singular": "gato", "plural": "gatos"},
    {"card": "vowel", "article": "a", "singular": "janela", "plural": "janelas"},
    {"card": "vowel", "article": "o", "singular": "amigo", "plural": "amigos"},
    {"card": "vowel", "article": "a", "singular": "porta", "plural": "portas"},
    {"card": "vowel", "article": "o", "singular": "café", "plural": "cafés"},
    {"card": "vowel", "article": "o", "singular": "dente", "plural": "dentes"},
    {"card": "vowel", "article": "a", "singular": "cidade", "plural": "cidades"},
    {"card": "vowel", "article": "o", "singular": "menu", "plural": "menus"},
    {"card": "vowel", "article": "a", "singular": "pessoa", "plural": "pessoas"},
    {"card": "ao", "article": "o", "singular": "coração", "plural": "corações"},
    {"card": "ao", "article": "a", "singular": "canção", "plural": "canções"},
    {"card": "ao", "article": "a", "singular": "lição", "plural": "lições"},
    {"card": "ao", "article": "a", "singular": "estação", "plural": "estações"},
    {"card": "ao", "article": "o", "singular": "avião", "plural": "aviões"},
    {"card": "ao", "article": "o", "singular": "limão", "plural": "limões"},
    {"card": "ao", "article": "o", "singular": "pão", "plural": "pães"},
    {"card": "ao", "article": "o", "singular": "capitão", "plural": "capitães"},
    {"card": "ao", "article": "a", "singular": "mão", "plural": "mãos"},
    {"card": "ao", "article": "o", "singular": "irmão", "plural": "irmãos"},
    {"card": "ao", "article": "o", "singular": "cidadão", "plural": "cidadãos"},
    {"card": "ao", "article": "o", "singular": "grão", "plural": "grãos"},
    {"card": "ao", "article": "o", "singular": "órgão", "plural": "órgãos"},
    {"card": "ao", "article": "a", "singular": "razão", "plural": "razões"},
    {"card": "es", "article": "a", "singular": "flor", "plural": "flores"},
    {"card": "es", "article": "a", "singular": "luz", "plural": "luzes"},
    {"card": "es", "article": "o", "singular": "mês", "plural": "meses"},
    {"card": "es", "article": "o", "singular": "país", "plural": "países"},
    {"card": "es", "article": "o", "singular": "professor", "plural": "professores"},
    {"card": "es", "article": "o", "singular": "lugar", "plural": "lugares"},
    {"card": "es", "article": "a", "singular": "mulher", "plural": "mulheres"},
    {"card": "es", "article": "a", "singular": "voz", "plural": "vozes"},
    {"card": "es", "article": "o", "singular": "rapaz", "plural": "rapazes"},
    {"card": "es", "article": "o", "singular": "juiz", "plural": "juízes"},
    {"card": "es", "article": "o", "singular": "português", "plural": "portugueses"},
    {"card": "es", "article": "o", "singular": "francês", "plural": "franceses"},
    {"card": "es", "article": "o", "singular": "gás", "plural": "gases"},
    {"card": "es", "article": "a", "singular": "cor", "plural": "cores"},
    {"card": "es", "article": "o", "singular": "amor", "plural": "amores"},
    {"card": "m", "article": "o", "singular": "homem", "plural": "homens"},
    {"card": "m", "article": "o", "singular": "jardim", "plural": "jardins"},
    {"card": "m", "article": "a", "singular": "viagem", "plural": "viagens"},
    {"card": "m", "article": "a", "singular": "imagem", "plural": "imagens"},
    {"card": "m", "article": "o", "singular": "jovem", "plural": "jovens"},
    {"card": "m", "article": "a", "singular": "garagem", "plural": "garagens"},
    {"card": "m", "article": "o", "singular": "som", "plural": "sons"},
    {"card": "m", "article": "o", "singular": "atum", "plural": "atuns"},
    {"card": "m", "article": "o", "singular": "álbum", "plural": "álbuns"},
    {"card": "m", "article": "o", "singular": "trem", "plural": "trens"},
    {"card": "m", "article": "o", "singular": "refém", "plural": "reféns"},
    {"card": "m", "article": "o", "singular": "armazém", "plural": "armazéns"},
    {"card": "l", "article": "o", "singular": "animal", "plural": "animais"},
    {"card": "l", "article": "o", "singular": "papel", "plural": "papéis"},
    {"card": "l", "article": "o", "singular": "lençol", "plural": "lençóis"},
    {"card": "l", "article": "", "singular": "fácil", "plural": "fáceis"},
    {"card": "l", "article": "o", "singular": "funil", "plural": "funis"},
    {"card": "l", "article": "o", "singular": "jornal", "plural": "jornais"},
    {"card": "l", "article": "o", "singular": "hotel", "plural": "hotéis"},
    {"card": "l", "article": "", "singular": "azul", "plural": "azuis"},
    {"card": "l", "article": "o", "singular": "canal", "plural": "canais"},
    {"card": "l", "article": "o", "singular": "barril", "plural": "barris"},
    {"card": "l", "article": "", "singular": "difícil", "plural": "difíceis"},
    {"card": "l", "article": "o", "singular": "espanhol", "plural": "espanhóis"},
    {"card": "l", "article": "", "singular": "útil", "plural": "úteis"},
    {"card": "l", "article": "o", "singular": "hospital", "plural": "hospitais"},
    {"card": "invariable", "article": "o", "singular": "lápis", "plural": "lápis"},
    {"card": "invariable", "article": "o", "singular": "ônibus", "plural": "ônibus"},
    {"card": "invariable", "article": "o", "singular": "tórax", "plural": "tórax"},
    {"card": "invariable", "article": "o", "singular": "pires", "plural": "pires"},
    {"card": "invariable", "article": "o", "singular": "atlas", "plural": "atlas"},
    {"card": "invariable", "article": "o", "singular": "vírus", "plural": "vírus"},
    {"card": "invariable", "article": "o", "singular": "cais", "plural": "cais"},
    {"card": "invariable", "article": "o", "singular": "tênis", "plural": "tênis"},
    {"card": "invariable", "article": "o", "singular": "clímax", "plural": "clímax"},
    {"card": "invariable", "article": "o", "singular": "oásis", "plural": "oásis"},
    {"card": "irregular", "article": "o", "singular": "cão", "plural": "cães"},
    {"card": "irregular", "article": "o", "singular": "alemão", "plural": "alemães"},
    {"card": "irregular", "article": "o", "singular": "cônsul", "plural": "cônsules"},
    {"card": "irregular", "article": "o", "singular": "caráter", "plural": "caracteres"},
    {"card": "irregular", "article": "o", "singular": "mal", "plural": "males"},
    {"card": "irregular", "article": "o", "singular": "júnior", "plural": "juniores"},
    {"card": "irregular", "article": "o", "singular": "sênior", "plural": "seniores"},
    {"card": "irregular", "article": "o", "singular": "escrivão", "plural": "escrivães"},
    {"card": "irregular", "article": "o", "singular": "catalão", "plural": "catalães"},
    {"card": "irregular", "article": "o", "singular": "capelão", "plural": "capelães"}
  ]
}
